import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { captureException } from '@sentry/react';

import { en } from '@/locales/en';
import { ja } from '@/locales/ja';

export const defaultNS = 'translation';
export const resources = {
  ja,
  en,
} as const;

i18n
  .use(initReactI18next)
  .use(LanguageDetector)
  .init({
    resources,
    fallbackLng: 'ja',
    supportedLngs: ['en', 'ja'],
    nonExplicitSupportedLngs: true,
    defaultNS,
    keySeparator: false,
    load: 'languageOnly',
    debug: process.env.NODE_ENV === 'development',
    react: {
      useSuspense: true,
    },
    interpolation: {
      escapeValue: false,
      formatSeparator: ',',
      format: (value: string, format?: string) => {
        if (format === 'uppercase') {
          return value.toUpperCase();
        }
        return value;
      },
    },
    saveMissing: true,
    missingKeyHandler: (lngs, ns, key) => {
      const info = JSON.stringify({ lngs, ns, key }, null, 2);
      captureException(new Error(`translation failed.\n${info}`));
    },
    returnNull: false,
  });

const DESC_LANG = 'ja';

export const isAscLang = () => i18n.languages[0] !== DESC_LANG;
export const isDescLang = () => i18n.languages[0] === DESC_LANG;
export const isJa = () => i18n.languages[0] === 'ja';

export default i18n;
